module.exports = __webpack_public_path__ + "img/comm-02-bg-intro.71f9347d.jpg";